import { jsx as _jsx } from "react/jsx-runtime";
import MuiCard from '@mui/material/Card';
import MuiCardActionArea from '@mui/material/CardActionArea';
import MuiCardActions from '@mui/material/CardActions';
import MuiCardContent from '@mui/material/CardContent';
import MuiCardHeader from '@mui/material/CardHeader';
import MuiCardMedia from '@mui/material/CardMedia';
import * as React from 'react';
import { getPaperElevationShadow } from '../paper';
import { styled } from '../styled';
import { usePaletteColor } from '../theme';
import { withVersion } from '../utils';
const StyledMuiCard = styled(MuiCard)(({ $backgroundColor, $width, $height, $boxShadow }) => ({
    backgroundColor: $backgroundColor,
    width: $width,
    height: $height,
    boxShadow: $boxShadow
}));
const CardImpl = React.forwardRef((props, ref) => {
    const { backgroundColor: _backgroundColor, width, height, elevation = 'S', ...cardProps } = props;
    const backgroundColor = usePaletteColor(_backgroundColor ?? 'background.paper');
    return (_jsx(StyledMuiCard, { ref: ref, ...cardProps, elevation: 0, "$backgroundColor": backgroundColor, "$width": width, "$height": height, "$boxShadow": cardProps.variant === 'outlined' || elevation === 'none'
            ? 'none'
            : getPaperElevationShadow(elevation) }));
});
export const Card = withVersion(CardImpl, '1.0.0');
export const CardContent = React.forwardRef(({ disabledPadding, sx, ...props }, ref) => (_jsx(MuiCardContent, { ref: ref, sx: disabledPadding
        ? {
            padding: 0,
            '&:last-child': { paddingBottom: 0 },
            ...sx
        }
        : sx, ...props })));
export const CardActions = MuiCardActions;
export const CardMedia = MuiCardMedia;
export const CardHeader = MuiCardHeader;
export const CardActionArea = MuiCardActionArea;
